import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { Menu } from '~/components/ActionMenu'
import type { TCatalogPostOriginType } from '~/types/catalog'

import ActionMenu from '~/components/ActionMenu'
import { FASTLY_PATH } from '~/const/asset'

import './styles.scss'

interface Props {
  actionsMenu: Menu
  id: string
  isDisabled: boolean
  mediaUrl: string
  mode?: 'detailed' | 'compact'
  prompt?: string
  templateOrigin: TCatalogPostOriginType
}

const CatalogPostCard = ({
  actionsMenu,
  id,
  isDisabled,
  mediaUrl,
  mode = 'detailed',
  prompt,
  templateOrigin,
}: Props): ReactElement => {
  const catalogMediaCardGridComponent = classNames(
    'catalog-post-card-component',
    `catalog-post-card-component--${mode}`,
    templateOrigin.toLocaleLowerCase(),
    { 'catalog-post-card-component--disabled': isDisabled }
  )

  return (
    <div className={catalogMediaCardGridComponent}>
      <div className="catalog-post-card-component__header">
        <div className="item-title">
          <span className="title" title={prompt || id}>
            {prompt || id}
          </span>
          <ActionMenu className="menu" menu={actionsMenu} menuTitle="ACTIONS" />
        </div>
      </div>
      <div className="catalog-post-card-component__media">
        <img
          className="catalog-post-card-component__media__image"
          src={`${FASTLY_PATH}${mediaUrl}?height=130&width=130&fit=cover`}
        />
      </div>
    </div>
  )
}
export default CatalogPostCard
